<template>
  <section class="paper-card">
    <slot />
  </section>
</template>

<script>
export default {
  name: "heim-card"
};
</script>

<style scoped>
h1 {
  font-weight: 600;
}
h2 {
  font-size: 0.9em;
}
.label {
  font-weight: 400;
}
header,
.row,
footer {
  padding: 0.8em 1em;
}
.row {
  display: flex;
  justify-content: space-between;
}
.row .label {
  width: 33%;
  display: none;
}
.row .inputs {
  width: 100%;
}
header,
.row {
  border-bottom: 1px solid #eeeeee;
}
footer {
  display: flex;
  justify-content: flex-end;
}
/* Wide layout: when the viewport width is bigger than 460px, layout
  changes to a wide layout. */
@media (min-width: 460px) {
  .row .label {
    display: block;
  }
  .row .inputs {
    width: 66%;
  }
}
</style>
